import { observer } from 'mobx-react-lite'
import { Dropdown, type IDropdownItem, Typography } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { RoleUpgradeRequestModalStore } from 'entities/UsersPermissions'
import { useProfilePageContext } from 'pages/conversations/pages/search/pages/profile/context/profileContext'
import { logV2SearchEvent } from 'pages/conversations/pages/search/utils/logSearchEvent'
import styles from './styles.module.scss'

export const Header = observer(() => {
  const entities = useEntitiesContext()
  const store = useProfilePageContext()
  const dropdownItems: IDropdownItem[] = [
    {
      id: 'new_message',
      label: 'New message',
      iconL: 'messageTextSquare',
      hotKey: 'M',
      onClick: () => {
        if (entities.usersStore.user?.isViewOnlyRole) {
          new RoleUpgradeRequestModalStore()
          return
        }
        logV2SearchEvent(
          'BigConvSlideout_Conversations_Plus_New_Message_Clicked',
          {
            event_id: 'bigconvslideout_conversations_plus_new_message_clicked',
          },
          entities
        )
        store.handleNewMessage()
      },
    },
    {
      id: 'make_a_call',
      label: 'Make a call',
      iconL: 'phone',
      hotKey: 'C',
      onClick: () => {
        if (entities.usersStore.user?.isViewOnlyRole) {
          new RoleUpgradeRequestModalStore()
          return
        }
        logV2SearchEvent(
          'BigConvSlideout_Conversations_Plus_Make_Call_Clicked',
          {
            event_id: 'bigconvslideout_conversations_plus_make_call_clicked',
          },
          entities
        )
        store.handleMakeACall()
      },
    },
  ]

  return (
    <div className={styles.wrap}>
      <Typography ariaLabel={'header__title'} variant={'body-md-medium'}>
        Conversations
      </Typography>
      <Dropdown
        items={dropdownItems}
        iconButtonProps={{
          size: 'medium',
          color: 'secondary',
          variant: 'icon',
          ariaLabel: 'header',
        }}
        placement={'bottom-start'}
        width={181}
        onChangeOpen={(value) => {
          if (value) {
            logV2SearchEvent(
              'BigConvSlideout_Conversations_Plus_Icon_Clicked',
              {
                event_id: 'bigconvslideout_conversations_plus_icon_clicked',
              },
              entities
            )
          }
        }}
      />
    </div>
  )
})
